export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الإدخال:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["متابعة"])}
}